import { debounce, noop } from "lodash";
import { createContext, useCallback, useEffect, useReducer } from "react";

const filterReducer = (state, action) => {
    if (action.type === "SET_FILTER_VISIBLE") {
        return {
            ...state,
            filterVisible: action.filterVisible,
        };
    }
    if (action.type === "SET_FILTER") {
        return {
            ...state,
            filter: action.filter,
        };
    }
    if (action.type === "SET_FILTER_VALUE") {
        return {
            ...state,
            filterValue: action.filter,
        };
    }

    return state;
};

const initState = (filter) => {
    return {
        filter: filter || {},
        filterValue: filter || {},
    };
};

export const useFilter = (options) => {
    const [state, dispatch] = useReducer(filterReducer, options.filter, initState);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const setFilterValue = useCallback(
        debounce(
            (filter) => {
                dispatch({
                    type: "SET_FILTER_VALUE",
                    filter: filter || {},
                });
            },
            1000,
            { trailing: true }
        ),
        [dispatch]
    );

    const setFilter = useCallback(
        (filter) => {
            dispatch({ type: "SET_FILTER", filter });
            setFilterValue(filter);
        },
        [dispatch, setFilterValue]
    );

    const setFilterVisible = useCallback(
        (filterVisible) => {
            dispatch({ type: "SET_FILTER_VISIBLE", filterVisible });
        },
        [dispatch]
    );

    return {
        filter: state.filter || {},
        filterVisible: state.filterVisible,
        filterValue: state.filterValue || {},
        setFilter,
        setFilterValue,
        setFilterVisible,
    };
};

export const FilterContext = createContext({
    filter: {},
    filterVisible: false,
    filterValue: {},
    setFilter: noop,
    setFilterValue: noop,
    setFilterVisible: noop,
});

export const Filter = ({ children, ...rest }) => {
    const value = useFilter(rest);
    return <FilterContext.Provider value={value}>{children}</FilterContext.Provider>;
};
